export const formatFilterMain = {
    areas: 'areas_ids',
    departments: 'departments_ids'
}

export const formatSort = {
    register: 'name',
    description: 'description',
    area: 'area',
    department: 'department',
}